export default "__VITE_ASSET__bXwLdM9n__$_?url__"